import { render, staticRenderFns } from "./KwPixel.vue?vue&type=template&id=33b0373a&scoped=true&"
import script from "./KwPixel.vue?vue&type=script&lang=js&"
export * from "./KwPixel.vue?vue&type=script&lang=js&"
import style0 from "./KwPixel.vue?vue&type=style&index=0&id=33b0373a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b0373a",
  null
  
)

export default component.exports